.error {
  display: flex;
  justify-content: center;
  padding: 16px;
  color: red;
  font-size: 18px;
}